<template>
  <div id="chart">
    <apexchart
      type="line"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>
<script>
export default {
  data: () => ({
    series: [
      {
        name: "IDOR Attacks",
        data: [28, 29, 33, 36, 32, 32, 33]
      },
      {
        name: "Login Bruteforce",
        data: [12, 27, 14, 5, 17, 53, 105]
      }
    ],
    chartOptions: {
      chart: {
        height: 250,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      colors: ["#f14668", "#feb019"],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "smooth",
      },
      title: {
        text: "Security Events",
        align: "left",
        style: {
          color: "#efefef",
        },
      },
      markers: {
        size: 1,
      },
      xaxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
        labels: {
          style: {
            colors: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff", "#fff"]
          }
        }
      },
      yaxis: {
        title: {
          text: "Security Events",
          style: {
            color: "#fff"
          },
        },
        min: 5,
        max: 40,
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5,
        labels: {
          colors: ["#fff", "#fff"]
        }
      },
      tooltip: {
        theme: "dark",
      },
      grid: {
        show: true,
        borderColor: "#576475",
        strokeDashArray: 0,
        position: "back",
        yaxis: {
          lines: {
            show: true,
          },
        },
        row: {
          colors: undefined,
          opacity: 0.5,
        },
        column: {
          colors: undefined,
          opacity: 0.5,
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
    },
  }),
};
</script>